import React from "react";
import { HomeTopCategoriesUI } from "./HomeTopCategoriesUI";
import { useFetchGet } from "../../../hooks";


function HomeTopCategories() {
    const { data, isLoading, hasError } = useFetchGet('https://app-nuokwylgla-uc.a.run.app/api/v1/categories/top');
    
    console.log('HomeTopCategories - isLoading:', isLoading);
    console.log('HomeTopCategories - data:', data);
    console.log('HomeTopCategories - hasError:', hasError);
    
    if (!isLoading) {
        if (data) {
            console.log('HomeTopCategories - Rendering with data:', data);
            return (
                <HomeTopCategoriesUI
                    data={data}
                />
            );
        } else {
            console.log('HomeTopCategories - No data available');
            return <div style={{ padding: '40px', textAlign: 'center', color: '#d7b547' }}>No hay categorías top disponibles</div>;
        }
    }
    
    console.log('HomeTopCategories - Loading...');
    return <div style={{ padding: '40px', textAlign: 'center', color: '#d7b547' }}>Cargando top categorías...</div>;
}

export { HomeTopCategories }